
 
<div>
  <section class="form-tasklist">
    <mat-card>
      <mat-card-title>
        Accept Terms
      </mat-card-title>

      <div style="margin-top:21px;">
        <form [formGroup]="formPermissions" autocomplete="nope">
          <mat-checkbox
            style="margin-left: 3px;"
            id="confirmReviewedTerms"
            name="confirmReviewedTerms"
            (change)="onChangeEventTerms($event)"
            formControlName="confirmReviewedTerms"
          >
          <div [innerHTML]="displayProgramRulesAcknowledgeContent"></div>
          </mat-checkbox>
          <span>
      
          </span>
        </form>
        <button
          mat-raised-button
          style="margin-top: 18px;"
          color="accent"
          [disabled]="disableSave"
          (click)="onClickYes()"
        >
          YES
        </button>
      </div>
    </mat-card>
  </section>
</div>